import { render, staticRenderFns } from "./ThrifterInfo.vue?vue&type=template&id=2934717d&scoped=true&"
import script from "./ThrifterInfo.vue?vue&type=script&lang=js&"
export * from "./ThrifterInfo.vue?vue&type=script&lang=js&"
import style0 from "./ThrifterInfo.vue?vue&type=style&index=0&id=2934717d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2934717d",
  null
  
)

export default component.exports